export default __webpack_public_path__ + "locales/ar-SA/Article.json?hash=e7e429e150ed68bcb8e81144ff09277f";